import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import {
  Card,
  ListGroup,
} from "react-bootstrap";
import icon from "../../../assets/images/icons8-call-102.png";
import Loader from "../../../jsx/components/Common/Loader";
import { assignLeadsToTelecaller } from "../../../services/LeadService";
import { formatDate } from "../../../utils/dateUtils";
const LeadList = ({
  title,
  leads = [],
  loading,
  showCallIcon = false,
  hoveredLeadId,
  setHoveredLeadId,
  refreshLeads,
  onCallLead,
  onViewLead,
  displayField = 'phone_no',
  showFollowupDate = false,
}) => {
  const navigate = useNavigate();
  const [pickingLeadId, setPickingLeadId] = useState(null);

  // ✅ SAFETY: Always work with array
  const safeLeads = Array.isArray(leads) ? leads : [];

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const admin_id = userDetails?.admin_id || 0;

  // Helper function to format display value
  const getDisplayValue = (lead) => {
    if (displayField === 'full_name') {
      return lead.full_name || lead.lead_name || `${lead.first_name || ''} ${lead.middle_name || ''} ${lead.last_name || ''}`.trim() || 'N/A';
    }
    return lead.phone_no || 'N/A';
  };

  const handlePick = async (lead) => {
    if (!admin_id) return;

    setPickingLeadId(lead.lead_id);

    const payload = {
      fresh_lead: lead?.isFresh ? "Yes" : "No",
      lead_ids: JSON.stringify([lead.lead_id]),
      telecaller_id: admin_id,
    };

    try {
      await assignLeadsToTelecaller(payload);
      navigate(`/app-lead-details/${lead.lead_id}`);
    } catch (error) {
      console.error("Error assigning lead:", error);
    } finally {
      setPickingLeadId(null);
    }
  };

  // ✅ Loading State
  if (loading) {
    return (
      <Card>
        <Card.Header>
          <Card.Title>{title}</Card.Title>
        </Card.Header>
        <Card.Body
          className="d-flex justify-content-center align-items-center"
          style={{ height: "300px" }}
        >
          <Loader />
        </Card.Body>
      </Card>
    );
  }

  // ✅ No Data State
  if (!loading && safeLeads.length === 0) {
    return (
      <Card>
        <Card.Header>
          <Card.Title>{title}</Card.Title>
        </Card.Header>
        <Card.Body
          className="d-flex justify-content-center align-items-center"
          style={{ height: "300px" }}
        >
          <p className="text-muted">No data found</p>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card>
      <Card.Header>
        <Card.Title>{title}</Card.Title>
      </Card.Header>

      <Card.Body
        style={{
          maxHeight: "300px",
          paddingTop: "0px",
          overflowY: "auto",
          paddingBottom: "10px",
        }}
      >
        <ListGroup as="ul" variant="flush">
          {safeLeads.map((lead, i) => (
            <ListGroup.Item
              key={i}
              as="li"
              onMouseEnter={() => setHoveredLeadId?.(lead.lead_id)}
              onMouseLeave={() => setHoveredLeadId?.(null)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "transparent",
              }}
            >
        <div>
  <div>{getDisplayValue(lead)}</div>

  {showFollowupDate && lead?.next_followup_date && (
    <small className="text-muted">
     {formatDate(lead.next_followup_date)}
     {lead?.next_followup_time && (
      <span style={{ marginLeft: "4px" }}>
        {lead.next_followup_time}
      </span>
    )}
    </small>
  )}
</div>
              <div className="d-flex align-items-center">
              {showCallIcon && lead?.phone_no && (
  <a href={`tel:${lead.phone_no}`}>
    <img
      src={icon}
      alt="Call"
      style={{
        cursor: "pointer",
        marginLeft: "5px",
        width: "24px",
        height: "24px",
      }}
    />
  </a>
)}

                {lead.telecaller_id &&
                lead.telecaller_id !== admin_id ? (
                  <span className="text-danger small ms-2">
                    Assigned
                  </span>
                ) : (
                  <span
                    onClick={() => onViewLead?.(lead)}
                    className="ms-3"
                    style={{ cursor: "pointer" }}
                  >
                    {pickingLeadId === lead.lead_id ? (
                      <span
                        className="spinner-border spinner-border-sm text-primary"
                        role="status"
                      ></span>
                    ) : (
                      <i className="fa fa-eye text-primary fs-5" />
                    )}
                  </span>
                )}
              </div>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Card.Body>
    </Card>
  );
};

LeadList.propTypes = {
  title: PropTypes.string.isRequired,
  leads: PropTypes.array,
  loading: PropTypes.bool,
  showCallIcon: PropTypes.bool,
  hoveredLeadId: PropTypes.any,
  setHoveredLeadId: PropTypes.func,
  refreshLeads: PropTypes.func,
  onCallLead: PropTypes.func,
  onViewLead: PropTypes.func,
  displayField: PropTypes.string,
};

export default LeadList;
